import { useNavigate } from 'react-router-dom'

import { EmployeeRouteMetaDocument, TerminatePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { apiClient } from 'modules/core/lib/mobx-rest'

import TerminateModal from 'modules/employees/components/Actions/TerminateModal'

const TerminatePage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { employee: sessionEmployee } = useCurrentSession()
  const { id: employeeIdParam } = useStrictParams<'id'>()
  const employeeId = employeeIdParam ?? sessionEmployee?.id

  const { data, client, loading } = useQuery(TerminatePageDocument, {
    variables: { employeeId },
  })

  const canSeeFormerEmployees = data?.employees._policies.seeFormerEmployees.can
  const employee = data?.employees.employee
  const canTerminateEmployees = data?.employees.employee?._policies?.terminateEmployees.can ?? false
  const terminationTypes = data?.contracts.terminationTypesConnection.nodes ?? []
  const navigationPath = canSeeFormerEmployees
    ? navigation.employees.id.fullPath({ id: employeeId })
    : navigation.employees.fullPath()

  const onSuccessTerminate = async () => {
    const mobxRestClient = apiClient()

    mobxRestClient.cache.evict('employees')
    mobxRestClient.cache.evict('users')
    mobxRestClient.cache.evict('memberships')
    mobxRestClient.cache.evict('teams')

    client.refetchQueries({ include: [EmployeeRouteMetaDocument] })
    navigate(navigationPath)
  }

  if (loading || !employee) {
    return null
  }

  return (
    <TerminateModal
      employee={employee}
      canTerminateEmployees={canTerminateEmployees}
      terminationTypes={terminationTypes}
      onClose={() => navigate(navigation.employees.id.fullPath({ id: employeeId }))}
      onSuccess={() => onSuccessTerminate()}
    />
  )
}

export default TerminatePage
